






































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import {
  BillingType,
  MeasuringStatesClient,
  ListProjectsToProgressQuery,
  DataSourceLoadOptionsBase,
  MeasuringStateProgressStatus,
  PeriodType,
  ProjectToProgressDto,
} from '@/data/web-api-client';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import BookKeepingNavigation from '@/modules/shared/navigation/BookKeepingNavigation.vue';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import dxDataGrid from 'devextreme/ui/data_grid';
import ProjectProgressionDialog from '@/modules/projectMeasuringStateOverview/components/ProjectProgressionDialog.vue';
import employeesRepository from '@/modules/employees/employeesRepository';

@Component({
  components: {
    Card,
    Datagrid,
    BookKeepingNavigation,
    ProjectProgressionDialog,
  },
})
export default class ProjectsToProgressOverview extends Vue {
  loading = false;

  billingType: TypeOrNull<BillingType> = null;
  billingTypeEnum = BillingType;

  periodType: PeriodType = PeriodType.ExcludingCurrentMonth;
  periodTypeEnum = PeriodType;

  totalProjectCount = 0;
  progressStatementProjectCount = 0;

  employees: any[] = [];

  private measuringStatesClient = new MeasuringStatesClient(undefined, this.$axios);

  async mounted() {
    await this.loadEmployees();
  }

  public openDetails(e: any) {
    if (e.row && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.$router.push({
        path: `/measuringstates/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}`,
      });
    }
  }

  private showProjectProgression(projectId: string) {
    if (!projectId) {
      return;
    }

    this.projectProgressionDialog.projectId = projectId;
    this.projectProgressionDialog.show = true;
    this.projectProgressionDialog.load();
  }

  async loadEmployees() {
    try {
      this.loading = true;
      this.employees = (await employeesRepository.get()).data;
      this.loading = false;
    } catch {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de medewerkers');
    }
  }

  get columns() {
    return [
      {
        cellTemplate: (cellElement: any, cellInfo: any) => {
          const icon = document.createElement('i');

          icon.classList.add('fas', 'fa-briefcase');
          icon.title = `Project ${cellInfo.data.projectName} openen`;

          icon.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const route = this.$router.resolve({ path: `/projects/${cellInfo.data.projectId}` });

            if (route?.href) {
              window.open(route.href, '_blank');
            }
          });

          cellElement.classList.add('text-center');
          cellElement.appendChild(icon);
        },
      },
      {
        dataField: 'projectId',
        visible: false,
      },
      {
        dataField: 'projectNumber',
        caption: 'Projectnr.',
      },
      {
        dataField: 'projectName',
        caption: 'Projectnaam',
      },
      {
        dataField: 'customer',
        caption: 'Referentie (klant)',
      },
      {
        dataField: 'documentNumber',
        caption: 'Meetstaatnr.',
      },
      {
        dataField: 'name',
        caption: 'Titel',
      },
      {
        dataField: 'projectLeader',
        caption: 'Projectleider',
        lookup: {
          dataSource: this.employeeSources,
        },
      },
      {
        dataField: 'qualityGuard',
        caption: 'Quality Guard',
        lookup: {
          dataSource: this.employeeSources,
        },
      },
      {
        dataField: 'subcontractor',
        caption: 'Onderaannemer',
      },
      {
        caption: 'Gevorderd',
        cellTemplate: (cellElement: any, cellInfo: any) => {
          const dto = cellInfo.data as ProjectToProgressDto;
          const circlesContainer = document.createElement('div');

          circlesContainer.classList.add('circles-container');

          const customerCircleContainer = document.createElement('div');
          const customerCircle = document.createElement('div');

          if (cellInfo.data.billingType === BillingType.AdvanceInvoice) {
            customerCircle.classList.add('fas', 'fa-file-pdf');
            customerCircle.style.fontSize = '20px';
          } else {
            customerCircleContainer.classList.add('circle-container');

            customerCircle.classList.add('circle');
            customerCircle.title = 'Niet gevorderd';

            if (dto.customerProgressStatus == MeasuringStateProgressStatus.PartialProgress) {
              customerCircle.classList.add('half-fill');
              customerCircle.title = 'Deels gevorderd';
            } else if (dto.customerProgressStatus == MeasuringStateProgressStatus.FullyProgressed) {
              customerCircle.classList.add('fill');
              customerCircle.title = 'Volledig gevorderd';
            }

            if (dto.customerProgressStatus != MeasuringStateProgressStatus.NoProgress) {
              customerCircle.title += `: ${dto.currentPeriodProgressStatementDocumentNumbers?.join(', ')}`;
            }
          }

          customerCircleContainer.appendChild(customerCircle);

          const subcontractorCircleContainer = document.createElement('div');

          subcontractorCircleContainer.classList.add('circle-container');

          const subcontractorCircle = document.createElement('div');

          subcontractorCircle.classList.add('circle');
          subcontractorCircle.title = 'Niet afgerekend';

          if (dto.subcontractorProgressStatus == MeasuringStateProgressStatus.PartialProgress) {
            subcontractorCircle.classList.add('half-fill');
            subcontractorCircle.title = 'Deels afgerekend';
          } else if (dto.subcontractorProgressStatus == MeasuringStateProgressStatus.FullyProgressed) {
            subcontractorCircle.classList.add('fill');
            subcontractorCircle.title = 'Volledig afgerekend';
          }

          if (dto.subcontractorProgressStatus != MeasuringStateProgressStatus.NoProgress) {
            subcontractorCircle.title += `: ${dto.currentPeriodSettlementDocumentNumbers?.join(', ')}`;
          }

          subcontractorCircleContainer.appendChild(subcontractorCircle);

          circlesContainer.appendChild(customerCircleContainer);
          circlesContainer.appendChild(subcontractorCircleContainer);

          cellElement.classList.add('text-center');
          cellElement.appendChild(circlesContainer);
        },
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Project progressie',
            icon: 'fas fa-tasks',
            onClick: (e: any) => {
              this.showProjectProgression(e.row.data.projectId);
            },
          },
          {
            hint: 'Meetstaat openen',
            icon: 'fas fa-share',
            onClick: (e: any) => {
              const route = this.$router.resolve({
                path: `/measuringstates/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}`,
              });

              if (route?.href) {
                window.open(route.href, '_blank');
              }
            },
          },
        ],
      },
    ];
  }

  get employeeSources() {
    return this.employees.map((e) => e.displayName);
  }

  get projectProgressionDialog() {
    return this.$refs?.projectProgressionDialog as ProjectProgressionDialog;
  }

  get gridInstance(): dxDataGrid {
    return (this.$refs.grid as any).$refs.projectsToProgressTable.instance as dxDataGrid;
  }

  get datasource() {
    const self = this;

    return new DataSource({
      store: new dxCustomStore({
        key: 'documentNumber',
        load: async (loadOptions) => {
          if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
            loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
          }

          loadOptions.requireTotalCount = true;

          const query = new ListProjectsToProgressQuery({
            billingType: self.billingType ?? undefined,
            periodType: self.periodType,
            options: DataSourceLoadOptionsBase.fromJS(loadOptions),
          });

          const result = await this.measuringStatesClient.listProjectsToProgress(query);

          this.totalProjectCount = result.totalProjectCount!;
          this.progressStatementProjectCount = result.progressStatementProjectCount!;

          return {
            data: result.data,
            totalCount: result.totalCount,
          };
        },
      }),
      paginate: true,
    });
  }

  @Watch('billingType')
  @Watch('periodType')
  async onPropsChanged(newValue: any, oldValue: any) {
    await this.gridInstance.refresh();
  }
}
